module.exports = __webpack_public_path__ + "img/stage-4.89eda237.png";